module.exports = __webpack_public_path__ + "img/Youtuber@2x.115e00fb.png";